import { render, staticRenderFns } from "./FormReject.vue?vue&type=template&id=3f69e73e&scoped=true&"
import script from "./FormReject.vue?vue&type=script&lang=js&"
export * from "./FormReject.vue?vue&type=script&lang=js&"
import style0 from "./FormReject.vue?vue&type=style&index=0&id=3f69e73e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f69e73e",
  null
  
)

export default component.exports